// extracted by mini-css-extract-plugin
export var activeDot = "_3q-c";
export var buttonContainer = "_3q-9";
export var channelButton = "_3q-a";
export var clickable = "_3q-d";
export var content = "_3q-0";
export var contentFull = "_3q-2";
export var contentThird = "_3q-1";
export var contentWrapper = "_3q-7";
export var description = "_3q-5";
export var heightShort = "_3q-f";
export var image = "_3q-3";
export var imageContainer = "_3q-4";
export var selectButton = "_3q-e";
export var spinnerContainer = "_3q-b";
export var titleContent = "_3q-8";
export var titleWrapper = "_3q-6";